import Abstract from '../../../framework/Abstract';
import { openModal } from '../../../store/actions/modal';

import './link-list-module.scss';

class LinkListModule extends Abstract {
	init() {
		this.registerListeners();
	}

	registerListeners = () => {
		const videoButton = this.root.querySelector('.js-video-modal');

		if (videoButton) {
			videoButton.addEventListener('click', this.onVideoPlay);
		}
	}

	onVideoPlay = (event) => {
		event.preventDefault();

		const { currentTarget: target } = event;
		const { href } = target;

		if (!href || href === '#') return;

		this.dispatch(openModal('video', { url: href }));
	}
}

export default LinkListModule;
